import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {TreatmentFracturesModel} from '../../models/treatment-fractures.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TdoDropdownModel} from '../../../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import {StaticDataService} from '../../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {TreatmentService} from '../../../../services/treatment.service';
import {Globals} from '../../../../globals';
import {TdoTableRowModel} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
import {MatSelectChange} from '@angular/material/select';

@Component({
  standalone: false,
  selector: 'app-treatment-fractures-dialog',
  templateUrl: './treatment-fractures-dialog.component.html',
  styleUrls: ['./treatment-fractures-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreatmentFracturesDialogComponent implements OnInit { 
  @ViewChild('tdoTable') tdoTable: TdoTableV2Component;

  isLoading = true;

  fractures: TreatmentFracturesModel[] = [];

  locationDropdownData: TdoDropdownModel[] = [];
  typeDropdownData: TdoDropdownModel[] = [];
  extensionDropdownData: TdoDropdownModel[] = [];
  transIlluminationDropdownData: TdoDropdownModel[] = []; 

  locationEnumItems: EnumValidValueItemModel[];
  typeEnumItems: EnumValidValueItemModel[];
  extensionEnumItems: EnumValidValueItemModel[];
  transIlluminationEnumItems: EnumValidValueItemModel[];
  CaseWorkItemToothId: string;
  toothNum: string;

  //treatmentModel: TreatmentEndoDataModel;

  constructor(private dialogRef: MatDialogRef<TreatmentFracturesDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: any,
              private treatmentService: TreatmentService,
              private globals: Globals,
              private staticDataService: StaticDataService,
              private cdr: ChangeDetectorRef) {
    //this.treatmentModel = data;
  }

  ngOnInit(): void {
    this.CaseWorkItemToothId = this.data.CaseWorkItemToothId;
    this.toothNum = this.data.toothNum;
    this.locationDropdownData = this.createEnumDropdownModels('enumEndoFractureLocation');
    this.typeDropdownData = this.createEnumDropdownModels('enumEndoFractureType');
    this.extensionDropdownData = this.createEnumDropdownModels('enumEndoFractureExtension');
    this.transIlluminationDropdownData = this.createEnumDropdownModels('enumEndoFractureTransillumination');

    this.locationEnumItems = this.staticDataService.getValidValueItemsByValidValueName('enumEndoFractureLocation');
    this.typeEnumItems = this.staticDataService.getValidValueItemsByValidValueName('enumEndoFractureType');
    this.extensionEnumItems = this.staticDataService.getValidValueItemsByValidValueName('enumEndoFractureExtension');
    this.transIlluminationEnumItems = this.staticDataService.getValidValueItemsByValidValueName('enumEndoFractureTransillumination');

    this.treatmentService.getFractures(this.CaseWorkItemToothId).subscribe((res) => {
      //console.log('ngOnInit getFractures res', res);
      if (!res || res.length === 0) {
        let model = new TreatmentFracturesModel();
        model.CaseWorkItemToothId = this.CaseWorkItemToothId;
        model.PatientId = this.globals.currentPatientId;
        this.fractures = [model];
      } 
      else {
        this.fractures = res;
      }
      this.isLoading = false;
      this.cdr.markForCheck();
    });
  }

  onAddFractureClick() {
    // Dummy data
    let model = new TreatmentFracturesModel();
    model.CaseWorkItemToothId = this.CaseWorkItemToothId;
    model.PatientId = this.globals.currentPatientId;
    this.isLoading = true;
    // console.log('onAddFractureClick saveFracture', model);
    this.treatmentService.saveFracture(model).subscribe((res) => {
      model = res;

      this.fractures =[];
      this.treatmentService.getFractures(this.CaseWorkItemToothId).subscribe((res) => {
        this.fractures = res;
        this.isLoading = false;
        this.cdr.markForCheck();
      });
    });
  }

  deleteFractureItem(row: TdoTableRowModel) {
    this.isLoading = true;
    row.model.xauditDeleted = true;
    // console.log('deleteFractureItem saveFracture', row.model);
    this.treatmentService.saveFracture(row.model).subscribe((res) => {
      row.model = res;

      this.fractures =[];
      this.treatmentService.getFractures(this.CaseWorkItemToothId).subscribe((res) => {
        this.fractures = res;
        this.isLoading = false;
        this.cdr.markForCheck();
      });

    });


  }

  onOkClick() {
    this.dialogRef.close(this.getPersistedFractures());
  }

  // The empty state shows an unsaved placeholder row so the user can start entering
  // data; only rows the API has actually persisted may be reported back to the caller.
  private getPersistedFractures(): TreatmentFracturesModel[] {
    return this.fractures.filter(fracture => !!fracture?.TreatmentFracturesID && !fracture.xauditDeleted);
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onShowAllChange(event: MatCheckboxChange) {

  }

  getLocationDropdownValue(location: Location) {
    if (this.locationDropdownData && this.locationDropdownData.length > 0) {
      const model = this.locationDropdownData.find(p => p.value.ValidValueItemId === location).value;
      if (model) {
        return model;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  private createEnumDropdownModels(enumName: string): TdoDropdownModel[] {
    const enums = this.staticDataService.getValidValueItemsByValidValueName(enumName);
    const ddModels: TdoDropdownModel[] = [];
    if (enums) {
      for (const vvi of enums) {
        ddModels.push(new TdoDropdownModel(vvi.ItemDisplayValue, vvi));
      }
    }
    return ddModels;
  }

  getToothNum(row: TdoTableRowModel) {
    return this.toothNum;
  }

  onTdoDropdownChange(event: MatSelectChange, row: TdoTableRowModel, enumID: string) {
    row.model[enumID] = event.value.ValidValueItemId;
    // console.log('onTdoDropdownChange saveFracture', row.model);
    const fractureIndex = this.fractures.indexOf(row.model);
    this.treatmentService.saveFracture(row.model).subscribe((res) => {
      row.model = res;
      // Keep the backing list in sync so the saved model (and its new
      // TreatmentFracturesID) is what the dialog reports back on OK.
      if (fractureIndex > -1) {
        this.fractures[fractureIndex] = res;
      }
    });
  }

  getValueByEnumId(locationEnumItems: EnumValidValueItemModel[], enumEndoFractureLocationID: string) {
    return locationEnumItems.find(p => p.ValidValueItemId === enumEndoFractureLocationID);
  }
}
